module.exports = __webpack_public_path__ + "img/Diego Garcia.8a327c85.svg";